import { FC, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import * as api from '../../api/generated';
import { KendoLoading } from '../../components';
import * as models from '../../models';
import OrganizationsCardGrid from './AdministrationOrganizationsGrid';

const AdministrationPage: FC = () => {
    const [organizations, setOrganizations] = useState<models.IOrganization[]>();

    const fetchData = async () => {
        try {
            const response = await api.administration.getOrganizations();
            setOrganizations(response);
        } catch (ex) {
            toast.error(ex.error[0]);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
        <div className="ms-Grid" dir="ltr">
            <div style={{ marginBottom: '20px' }} className="ms-Grid-row">
                {!organizations && <KendoLoading />}
                {organizations && <OrganizationsCardGrid organizations={organizations} />}
            </div>
        </div>
    );
};

export default AdministrationPage;
